import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import OnboardingRokuContainer from '../../containers/login/OnboardingRokuContainer'

export default function OnboardingRokuComponent() {
  const { keycloak } = useSelector(state => state.auth)
  const navigate = useNavigate()
  // const heroVideosId = [
  //   '686be33ec3625256db97d2d4', //Aguas de Oro "contenido exclusivo"
  //   '68d2f03f70711a81fd009b4d', //Reunión de Superados
  //   '688c094fdd5f6a1c345da886', //Jardín de Olivia
  //   '68e3d1aa0baf1e412260bbec', //El internado
  //   '698b946646496bb88761accb', //Viña 2026
  // ]
  // const randomVideo = heroVideosId[Math.floor(Math.random() * heroVideosId.length)];
  const randomVideo = "698b946646496bb88761accb"

  return (
    <OnboardingRokuContainer navigate={navigate} keycloak={keycloak} randomVideo={randomVideo} />
  )
}